export default {
    assign_firmware_title: "Asignar el Firmware",
    assign_firmware_the_device_is_already_added: "El dispositivo ya está añadido",
    assign_firmware_of_device_is_higher: "El firmware actual del dispositivo es superior",
    assign_firmware_hardware_version_not_valid: "La versión de hardware del dispositivo no es válida",
    assign_firmware_the_device_manu_must_be_vidfleet: "El fabricante del dispositivo debe ser Vidfleet",
    assign_firmware_no_device_found: "No se ha encontrado ningún dispositivo",
    assign_firmware_the_firmware_was_assigned: "El firmware fue asignado",
    assign_firmware_unable_to_update_fimware: "No se puede actualizar el firmware",
    assign_firmware_Id: "Id",
    assign_firmware_hardware_version: "Versión de hardware",
    assign_firmware_firmware_version: "Versión del firmware",
    assign_firmware_firmware_type: "Tipo de firmware",
    assign_firmware_status: "Estado",
    assign_firmware_default: "Por defecto",
    assign_firmware_file: "Archivo",
    assign_firmware_description: "Descripción",
    assign_firmware_apply_scopes: "Aplicar alcances",
    assign_firmware_partial_message: "Solo los dispositivos listados abajo tomarán este FIRMWARE",
    assign_firmware_default_message: 'Éste FIRMWARE será aplicado como "POR DEFECTO" para TODOS los nuevos dispositivos adicionados a la PLATAFORMA',
    assign_firmware_all_message: 'Éste FIRMWARE será applicado a "TODOS" los dispositivos existentes en la PLATAFORMA',
    assign_firmware_all_error: "No se puede asignar a todos los dispositivos porque el firmware no es el predeterminado",
    assign_firmware_current_firmware: "Firmware actual",
    assign_firmware_apply: "Aplicar",
    assign_firmware_serial: "Serial",
    assign_firmware_imei: "IMEI",
    assign_firmware_imei_or_serial: "IMEI o serial",
    assign_firmware_firmware_details: "Detalles del firmware",
}